<template>
    <div>
        <div class="comment-replies__list">
            <RootComment v-for="comment in slicePartOfComments"
                         :key="comment.id"
                         :comment="comment"/>
        </div>
        <button class="comment-replies__show-more-btn" v-if="hasMoreComments"
                @click="showNextComments">{{ btnText }}
        </button>
    </div>
</template>

<script>
    import {extractCommentByIds} from "VueApps/comments/services/extractCommentByIds";
    import RootComment from "VueApps/comments/components/comment/RootComment.vue";

    const DEFAULT_NUMBER_OF_SHOWING_COMMENTS = 5;
    const NUMBER_OF_SHOWING_COMMENTS = 5;

    export default {
        name: "RootCommentList",
        components: {
            RootComment,
        },
        data() {
            return {
                commentsToShow: DEFAULT_NUMBER_OF_SHOWING_COMMENTS,
            }
        },
        computed: {
            rootComments: function () {
                return extractCommentByIds(
                    this.$store.state.componentState.comments,
                    this.$store.state.componentState.rootIds
                )
            },
            slicePartOfComments: function () {
                return this.rootComments.slice(0, this.commentsToShow);
            },
            hasMoreComments: function () {
                return this.$store.state.componentState.rootIds.length > this.commentsToShow;
            },
            btnText: function () {
                return this.$isMobile() ?
                    'Больше комментариев' :
                    'Показать больше комментариев';
            },
        },
        methods: {
            showNextComments: function () {
                this.commentsToShow += NUMBER_OF_SHOWING_COMMENTS;
            },
        }
    }
</script>

<style scoped>

</style>
